<template>
  <div class="reviews-summary">
    <div class="reviews-summary__score">
      {{ stats.rating }}
    </div>

    <ReviewStars
      class="reviews-summary__stars"
      :rating="stats.rating"
    />

    <div class="reviews-summary__reviews">
      {{ $t('Based on reviews', { count: stats.count }, stats.count) }}
    </div>
  </div>
</template>

<script setup lang="ts">
export type Props = {
  stats: {
    score: number
    count: number
    rating: number
  }
}

defineProps<Props>()
</script>

<style>
@import url("~layers/app/components/Review/Summary.css");
</style>
